import * as i0 from "@angular/core";
export var StorageItemEnum;
(function (StorageItemEnum) {
    StorageItemEnum["WidgetOptions"] = "widgetOptions";
    StorageItemEnum["Locale"] = "locale";
    StorageItemEnum["GroupRestriction"] = "GroupRestriction";
    StorageItemEnum["UserAppId"] = "userAppId";
    StorageItemEnum["RememberMeEmail"] = "rememberMeEmail";
    StorageItemEnum["LabelConversionSeen"] = "labelConversionSeen";
    StorageItemEnum["DefaultGroupEdit"] = "defaultGroupEdit";
    StorageItemEnum["DefaultCollectionId"] = "defaultCollectionId";
})(StorageItemEnum || (StorageItemEnum = {}));
export var SessionStorageEnum;
(function (SessionStorageEnum) {
    SessionStorageEnum["UserMessagesSeen"] = "userMessagesSeen";
})(SessionStorageEnum || (SessionStorageEnum = {}));
export class StorageService {
    constructor() {
    }
    getLocalItem(key) {
        return localStorage.getItem(`${key}`);
    }
    getLocalJSON(key) {
        const value = this.getLocalItem(key);
        return value ? JSON.parse(value) : null;
    }
    setLocalItem(key, value) {
        const serializedValue = typeof (value) === 'object' ? JSON.stringify(value) : `${value}`;
        try {
            localStorage.setItem(`${key}`, serializedValue);
            return true;
        }
        catch (e) {
            return false;
        }
    }
    removeLocalItem(key) {
        localStorage.removeItem(`${key}`);
    }
    getSessionItem(key) {
        const entry = sessionStorage.getItem(`${key}`);
        if (entry) {
            return JSON.parse(entry);
        }
        else {
            return null;
        }
    }
    setSessionItem(key, entry) {
        const json = JSON.stringify(entry);
        try {
            sessionStorage.setItem(`${key}`, json);
            return true;
        }
        catch (e) {
            return false;
        }
    }
    removeSessionItem(key) {
        sessionStorage.removeItem(`${key}`);
    }
    clearStorage() {
        this.clearLocalStorage();
        this.clearSessionStorage();
    }
    clearLocalStorage() {
        localStorage.clear();
    }
    clearSessionStorage() {
        sessionStorage.clear();
    }
}
StorageService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function StorageService_Factory() { return new StorageService(); }, token: StorageService, providedIn: "root" });
